import { useAtomValue, useSetAtom } from 'jotai';

import { InventoryItemCondition } from '@ekhodealer/ekho-common';
import { SkeletonRect,
Stack } from '@ekhodealer/ekho-common/rev';

import type { FiltersDrawerCheckboxGroupItem } from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { AccordionSection } from '@common/components/AccordionSection';
import { FiltersDrawerCheckboxGroup } from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { conditionFilterAtom, updateConditionFilterAtom } from '../../../atoms/inventoryAtoms';
import { useInventoryFilterFacetCounts } from '../../../hooks/useInventoryFilterFacetCounts';


const CONDITION_LABELS: Record<InventoryItemCondition, string> = {
	[InventoryItemCondition.NEW]: 'New',
	[InventoryItemCondition.USED]: 'Used',
	[InventoryItemCondition.CONSIGNED]: 'Consigned',
	[InventoryItemCondition.UNDEFINED]: 'Undefined',
};

const CONDITION_ORDER = [
	InventoryItemCondition.NEW,
	InventoryItemCondition.USED,
	InventoryItemCondition.CONSIGNED,
];

export function ConditionSection() {
	const conditions = useAtomValue(conditionFilterAtom);
	const setConditions = useSetAtom(updateConditionFilterAtom);

	// Get dynamic facet counts from the search response
	const { conditionCounts, isLoading } = useInventoryFilterFacetCounts();

	// Build condition items with dynamic counts from facets
	// Use predefined order for consistency
	const conditionItems: FiltersDrawerCheckboxGroupItem[] = CONDITION_ORDER.map((condition) => ({
		value: condition,
		label: CONDITION_LABELS[condition],
		count: conditionCounts[condition] || 0,
	})).filter((item) => item.count > 0 || conditions.includes(item.value as InventoryItemCondition));

	// Wrapper function to convert string[] to InventoryItemCondition[]
	const handleChange = (values: string[]) => {
		setConditions(values as InventoryItemCondition[]);
	};

	return (
		<AccordionSection title='Condition'>
			{isLoading ? (
				<Stack itemsSpacing='8'>
					<SkeletonRect width='100%' height='24px' />
					<SkeletonRect width='100%' height='24px' />
				</Stack>
			) : (
				<FiltersDrawerCheckboxGroup
					items={conditionItems}
					value={conditions}
					onChange={handleChange}
				/>
			)}
		</AccordionSection>
	);
}
